import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import StyledTableContainer from "../../newTestPrep/newComponent/TableContainer";
import { validateRuppes } from "../../utils/formatTime";

export default function TaargetRevenueBreakdown({
  selectedYear,
  monthName,
  detailsData,
  countryId
}) {

  const userRole=localStorage.getItem('userRole')
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h4" textAlign="center">
            {monthName} {selectedYear}
          </Typography>
        </Grid>

{(["center_admin", "data_entry"].includes(userRole)) && (
        <Grid item xs={12}>
          <StyledTableContainer component={Paper} borderLeft={true}>
            <Table
              sx={{ tableLayout: "fixed" }}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell>Advisor Name</TableCell>
                  <TableCell>Target ({validateRuppes (countryId)})</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detailsData.length === 0 ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h5">No data available</Typography>
                  </Grid>
                ) : (
                  detailsData.map((row, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f0f0f0" : "inherit",
                      }}
                    >
                      <TableCell
                        style={{
                          color:
                            index === detailsData.length - 1
                              ? "black"
                              : "inherit",
                              fontWeight:     index === detailsData.length - 1 ? 700:500
                        }}
                      >
                        {row?.user_id?.first_name} {row?.user_id?.last_name}
                      </TableCell>
                      <TableCell
                        style={{
                          color:
                            index === detailsData.length - 1
                              ? "black"
                              : "inherit",
                              fontWeight:     index === detailsData.length - 1 ? 700:500
                        }}
                      >
                        {row?.value}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
            {/* <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={payments.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  /> */}
          </StyledTableContainer>
        </Grid>
         )}

{["advisor"].includes(userRole) && (
        <Grid item xs={12}>
          <StyledTableContainer component={Paper} borderLeft={true}>
            <Table
              sx={{ tableLayout: "fixed" }}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Target</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detailsData.length === 0 ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h5">No data available</Typography>
                  </Grid>
                ) : (
                  detailsData.map((row, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f0f0f0" : "inherit",
                      }}
                    >
                      <TableCell
                        style={{
                          color:
                            index === detailsData.length - 1
                              ? "black"
                              : "inherit",
                              fontWeight:     index === detailsData.length - 1 ? 700:500
                        }}
                      >
                        {row?.product_id?.name} 
                      </TableCell>
                      <TableCell
                        style={{
                          color:
                            index === detailsData.length - 1
                              ? "black"
                              : "inherit",
                              fontWeight:     index === detailsData.length - 1 ? 700:500
                        }}
                      >
                        {row?.rev_target}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
            {/* <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={payments.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  /> */}
          </StyledTableContainer>
        </Grid>
         )}

      </Grid>
    </>
  );
}
